var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardRoi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8335",
    "data-name": "Rectangle 8335",
    width: 21,
    height: 22,
    transform: "translate(0 0.211)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15895",
    "data-name": "Group 15895",
    transform: "translate(-0.363 -0.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15894",
    "data-name": "Group 15894",
    transform: "translate(0.363)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5782",
    "data-name": "Path 5782",
    d: "M0,1.156V18.115a4.242,4.242,0,0,0,4.24,4.24H19.656a1.156,1.156,0,0,0,0-2.313H4.24a1.928,1.928,0,0,1-1.927-1.927V1.156A1.156,1.156,0,0,0,0,1.156",
    transform: "translate(-0.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5783",
    "data-name": "Path 5783",
    d: "M45,10.156V20.948a1.156,1.156,0,0,0,2.313,0V10.156a1.156,1.156,0,0,0-2.313,0",
    transform: "translate(-27.966 -5.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5784",
    "data-name": "Path 5784",
    d: "M30,18.156v7.708a1.156,1.156,0,1,0,2.313,0V18.156a1.156,1.156,0,1,0-2.313,0",
    transform: "translate(-18.748 -10.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5785",
    "data-name": "Path 5785",
    d: "M15,26.156v4.625a1.156,1.156,0,1,0,2.313,0V26.156a1.156,1.156,0,0,0-2.313,0",
    transform: "translate(-9.529 -15.364)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRoi);
export default __webpack_public_path__ + "static/media/dashboard-roi.679d59d95b41cf8dd98d4f1de5367f42.svg";
export { ForwardRef as ReactComponent };